
export const MonthOptions = {
    byDate: 1,
    byWeek: 2,
    lastDayOfMonth: 3,
}